import { Modal } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../Store";

const LoadingBar = () => {

    const isShowLoadingBar = useSelector((state: RootState) => state.LoadingBarReducer.isShowLoadingBar); // 로딩바 표시 처리를 위한 state

    return (
        <Modal open={isShowLoadingBar}>
            <img src={"/Images/main_loadingbar_" + Math.floor(Math.random() * 10) + ".gif"} alt="" style={{
                position: 'absolute', top: '50%', left: '50%',
                transform: 'translate(-50%, -50%)', borderWidth: 0, outline: 'none'
            }} />
        </Modal>
    )
}

export default LoadingBar;
